import React from "react";

export function Grid({ children }: any) {
  return <div className="flex flex-wrap gap-4">{children}</div>;
}
